module.exports = __webpack_public_path__ + "img/complete.76f7d19d.svg";